module.exports = {
    apiPath: 'https://member-kr2.unicity.com/unifoapi/backend/crud',
    domain: 'https://ushop-kr.unicity.com/korea',
    // payApiPath: 'https://member-calls2-kr.unicity.com/payments-v2'
    payApiPath: 'https://member-calls2-kr.unicity.com/payments-v2'
    // payApiPath : 'http://localhost:5000'
}
